/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/12/22, 8:25 AM
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import isNaN from 'lodash/isNaN';

type pathArrayProps = {
  label: string;
  href: string;
};

const BreadCrumb = () => {
  const location = useLocation();

  const [breadcrumbs, setBreadcrumbs] = useState<pathArrayProps[]>([]);

  const removeBracesIfAny = (string: string) => {
    if (string[0] === '[' && string[string.length - 1] === ']') {
      return string.slice(1, -1);
    }

    return string.replace(/_/g, ' ');
  };

  console.log(location);

  useEffect(() => {
    const linkPath = location.pathname.split('/');
    const labelPath = location.pathname.split('/');

    linkPath.shift();
    labelPath.shift();

    const pathArray = linkPath.map((path, i) => {
      return {
        label: !isNaN(+path) ? removeBracesIfAny(labelPath[i]) : path,
        href: '/' + linkPath.slice(0, i + 1).join('/'),
      };
    });

    setBreadcrumbs(pathArray);
  }, [location.pathname]);

  if (!breadcrumbs) {
    return null;
  }

  return (
    <ul className="flex h-full items-center justify-center space-x-4 text-xl font-medium text-gray-400">
      <li className="hover:text-gray-800">
        <Link to="/dashboard">Dashboard</Link>
      </li>

      {breadcrumbs.map((breadcrumb, _i: number) => {
        return (
          <li
            key={breadcrumb.href}
            className={
              location.pathname === breadcrumb.href
                ? 'mt-1 box-content flex h-full items-center border-b-4 border-primary-500 px-4 capitalize text-black'
                : '-mt-1 px-4 capitalize hover:text-gray-800'
            }
          >
            <Link to={breadcrumb.href}>
              {decodeURI(breadcrumb.label).split('?')[0].replace(/_/g, ' ')}
            </Link>
          </li>
        );
      })}
    </ul>
  );
};

export default BreadCrumb;
